<app-header></app-header>
<div [ngStyle]="style"><router-outlet></router-outlet></div>
<app-footer></app-footer>
<div class="dialog-container">
    <div #dialog></div>
</div>